import {
  Activity,
  Archive,
  BookOpen,
  Compass,
  Gift,
  Layers,
  RotateCcw,
  Target,
  Trophy,
  Wrench,
} from 'lucide-solid'
import type { Component } from 'solid-js'

export type CourseGroupKey = 'core' | 'orient' | 'series' | 'free'

export interface CourseDecor {
  icon: Component<{ size?: number | string }>
  color: string
  group: CourseGroupKey
  rank: number
}

const DEFAULT_DECOR: CourseDecor = {
  icon: BookOpen,
  color: '#5b6b7d',
  group: 'series',
  rank: 90,
}

const RULES: { test: RegExp; decor: CourseDecor }[] = [
  { test: /orientation/i, decor: { icon: Compass, color: '#c98a2b', group: 'orient', rank: 0 } },
  { test: /free content/i, decor: { icon: Gift, color: '#1aa3a3', group: 'free', rank: 0 } },
  { test: /legacy/i, decor: { icon: Archive, color: '#9b7b3f', group: 'series', rank: 40 } },
  { test: /(beginner|revealed)/i, decor: { icon: BookOpen, color: '#d49a08', group: 'core', rank: 1 } },
  { test: /(intermediate|refined)/i, decor: { icon: Layers, color: '#e07b39', group: 'core', rank: 2 } },
  { test: /(advanced|rewarded)/i, decor: { icon: Trophy, color: '#0a8f63', group: 'core', rank: 3 } },
  { test: /trading essentials/i, decor: { icon: Wrench, color: '#2f7fd1', group: 'series', rank: 10 } },
  { test: /mindset/i, decor: { icon: Activity, color: '#7c5cd6', group: 'series', rank: 20 } },
  { test: /case stud/i, decor: { icon: Target, color: '#5b6b7d', group: 'series', rank: 30 } },
  { test: /reset ready/i, decor: { icon: RotateCcw, color: '#e5483d', group: 'series', rank: 35 } },
]

export function getCourseDecor(title: string): CourseDecor {
  const match = RULES.find((rule) => rule.test.test(title))
  return match ? match.decor : DEFAULT_DECOR
}

export const GROUPS: { key: CourseGroupKey; label: string; sub: string }[] = [
  { key: 'core', label: 'The HVF Method', sub: 'A sequential program — each course unlocks the next' },
  { key: 'orient', label: 'Orientation', sub: 'Start here — the official bootcamp for new recruits' },
  { key: 'series', label: 'Series & Specialisations', sub: 'Standalone deep-dives — take them in any order' },
  { key: 'free', label: 'Free Content', sub: 'Content made available for free' },
]
